import React, { Component } from "react";
import { isMobileApp } from "../../../actions/Util";
import Icon from "./Icon";

class Autocompletesearch extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      inputValue: props.value || "",
      showSuggestions: false,
      selectedIndex: -1,
      forceShowAll: false,
      isTyping: false,
      dropdownDirection: "down",
      scanMode: false,
      isScanning: false,
      showInfoText: false,
    };
    
    this.debouncedValue = "";
    this.debounceTimer = null;
    this.wrapperRef = React.createRef();
    this.suggestionsRef = React.createRef();
    this.itemRefs = [];
    this.inputRef = React.createRef();
    
    // Bind methods
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleToggleSuggestions = this.handleToggleSuggestions.bind(this);
    this.toggleScanMode = this.toggleScanMode.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getTooltipPositionClasses = this.getTooltipPositionClasses.bind(this);
    this.getDefaultDisplayValue = this.getDefaultDisplayValue.bind(this);
    this.isItemSelected = this.isItemSelected.bind(this);
    this.scrollIntoView = this.scrollIntoView.bind(this);
    this.debounce = this.debounce.bind(this);
  }
  
  // Debounce function implementation
  debounce(func, delay) {
    let timer;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }
  
  getTooltipPositionClasses(position) {
    switch(position) {
      case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
      case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-2';
      case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-2';
      case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-2';
      default: return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
    }
  }
  
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    
    // Create debounced version of updateDebouncedValue
    this.debouncedUpdate = this.debounce((value) => {
      this.debouncedValue = value;
      this.forceUpdate();
    }, 500);

    console.log("data",this.props.data);
  }
  
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    // Update input value when prop changes
    if (prevProps.value !== this.props.value) {
      this.setState({ inputValue: this.props.value || "" });
    }

       if (prevProps.data !== this.props.data) {
    console.log("data change");
    }
    
    // Focus input when entering scan mode
    if (prevState.scanMode !== this.state.scanMode && this.state.scanMode && this.inputRef.current) {
      this.inputRef.current.focus();
    }
    
    // Check dropdown direction when suggestions are shown
    if (this.state.showSuggestions !== prevState.showSuggestions && this.state.showSuggestions && this.wrapperRef.current) {
      const inputRect = this.wrapperRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - inputRect.bottom;
      const spaceAbove = inputRect.top;
      
      if (spaceBelow < 250 && spaceAbove > spaceBelow) {
        this.setState({ dropdownDirection: 'up' });
      } else {
        this.setState({ dropdownDirection: 'down' });
      }
    }


    
    // Reset isTyping when suggestions are closed
    if (!this.state.showSuggestions && prevState.showSuggestions) {
      this.setState({ isTyping: false });
    }
  }
  
  handleClickOutside(event) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ 
        showSuggestions: false,
        forceShowAll: false 
      });
    }
  }
  
  getFilteredData() {
    const { scanMode, inputValue, forceShowAll, isTyping, showSuggestions } = this.state;
    const { data = [], defaultDataCount = 5, filterKey = "text" } = this.props;
    
    const searchValue = this.debouncedValue.toLowerCase();
    
    if (scanMode) {
      return [];
    }
    
    if (!isTyping && showSuggestions) {
      return data.slice(0, defaultDataCount);
    }
    
    if (this.debouncedValue) {
      return data.filter((item) => {
        if (Array.isArray(filterKey)) {
          return filterKey.some((key) =>
            String(item[key] || "")
              .toLowerCase()
              .includes(searchValue)
          );
        }
        return String(item[filterKey] || "")
          .toLowerCase()
          .includes(searchValue);
      });
    }
    
    return data.slice(0, defaultDataCount);
  }
  
  getDefaultDisplayValue(item) {
    const { filterKey = "text" } = this.props;
    if (Array.isArray(filterKey)) {
      return item[filterKey[0]] || "";
    }
    return item[filterKey] || "";
  }
  
  isItemSelected(item) {
    const { inputValue } = this.state;
    const displayValue = this.getDefaultDisplayValue(item);
    return displayValue === inputValue;
  }
  
  handleItemClick(item) {
    const { clearInputValueAfterSelect, onChange, onSelect } = this.props;
    const displayValue = this.getDefaultDisplayValue(item);
    
    if (clearInputValueAfterSelect) {
      this.setState({ inputValue: "" });
      onChange("");
    } else {
      this.setState({ inputValue: displayValue });
      onChange(displayValue);
    }
    
    if (onSelect) {
      onSelect(item);
    }
    
    this.setState({ 
      showSuggestions: false,
      forceShowAll: false 
    });
  }
  
  handleFocus() {
    const { scanMode } = this.state;
    const { clearInputValueAfterSelect, onChange } = this.props;
    
    if (scanMode) return;
    
    if (clearInputValueAfterSelect) {
      this.setState({ inputValue: "" });
      onChange("");
    }
    
    this.setState({ 
      showSuggestions: true,
      selectedIndex: -1,
      forceShowAll: true 
    });
  }
  
  handleToggleSuggestions() {
    const { scanMode, showSuggestions } = this.state;
    if (scanMode) return;
    
    const willShow = !showSuggestions;
    this.setState({ 
      showSuggestions: willShow,
      forceShowAll: willShow,
      selectedIndex: -1,
      isTyping: false 
    });
  }
  
  toggleScanMode() {
    const { scanMode } = this.state;
    const newScanMode = !scanMode;
    
    this.setState({ 
      scanMode: newScanMode,
      inputValue: "",
      showSuggestions: false 
    });
    
    if (newScanMode) {
      this.props.onChange("");
    }
  }
  
  handleKeyDown(e) {
    const { scanMode, showSuggestions, selectedIndex } = this.state;
    const { onScan, onChange } = this.props;
    const filteredData = this.getFilteredData();
    
    // Handle Enter key for scan mode
    if (e.key === "Enter" && scanMode) {
      const { inputValue } = this.state;
      if (inputValue.trim()) {
        this.setState({ isScanning: true });
        
        if (onScan) {
          onScan(inputValue);
          this.setState({ inputValue: "" });
        } else {
          onChange(inputValue);
          this.setState({ inputValue: "" });
        }
        
        this.setState({ isScanning: false });
        e.preventDefault();
        return;
      }
    }
    
    // Handle Escape to exit scan mode
    if (e.key === "Escape" && scanMode) {
      this.setState({ 
        scanMode: false,
        isScanning: false 
      });
      return;
    }
    
    // Scan mode में keyboard navigation disable करें
    if (scanMode) return;
    
    if (!showSuggestions || filteredData.length === 0) return;
    
    if (e.key === "Enter") {
      e.preventDefault();
      
      if (filteredData.length === 1) {
        this.handleItemClick(filteredData[0]);
      } else if (selectedIndex >= 0 && selectedIndex < filteredData.length) {
        this.handleItemClick(filteredData[selectedIndex]);
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      const nextIndex = selectedIndex + 1;
      const newIndex = nextIndex < filteredData.length ? nextIndex : 0;
      this.setState({ selectedIndex: newIndex });
      this.scrollIntoView(newIndex);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const prevIndex = selectedIndex - 1;
      const newIndex = prevIndex >= 0 ? prevIndex : filteredData.length - 1;
      this.setState({ selectedIndex: newIndex });
      this.scrollIntoView(newIndex);
    } else if (e.key === "Escape") {
      this.setState({ 
        showSuggestions: false,
        forceShowAll: false 
      });
    }
  }
  
  handleInputChange(e) {
    const newValue = e.target.value;
    const { scanMode, showSuggestions } = this.state;
    const { onChange } = this.props;
    
    this.setState({ 
      inputValue: newValue,
      selectedIndex: -1,
      forceShowAll: false,
      isTyping: true 
    });
    
    // Use the debounced function
    if (this.debouncedUpdate) {
      this.debouncedUpdate(newValue);
    }
    
    if (!scanMode) {
      onChange(newValue);
    }
    
    if (!scanMode && !showSuggestions) {
      this.setState({ showSuggestions: true });
    }
  }
  
  scrollIntoView(index) {
    if (this.itemRefs[index] && this.suggestionsRef.current) {
      const item = this.itemRefs[index];
      const container = this.suggestionsRef.current;
      const itemTop = item.offsetTop;
      const itemBottom = itemTop + item.offsetHeight;
      const containerTop = container.scrollTop;
      const containerBottom = containerTop + container.offsetHeight;
      
      if (itemTop < containerTop) {
        container.scrollTop = itemTop;
      } else if (itemBottom > containerBottom) {
        container.scrollTop = itemBottom - container.offsetHeight;
      }
    }
  }
  
  defaultRenderSuggestion(item, index) {
    const { selectedIndex } = this.state;
    
    return (
      <div
        style={{
          padding: "12px",
          backgroundColor: selectedIndex === index ? "#6e2d90" : (this.isItemSelected(item) ? "#F5EBFB" : "transparent"),
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          cursor: "pointer"
        }}
        onClick={() => this.handleItemClick(item)}
        onMouseEnter={() => this.setState({ selectedIndex: index })}
        ref={(el) => (this.itemRefs[index] = el)}
      >
        <p style={{ 
          fontWeight: "500",
          color: selectedIndex === index ? "#FFFFFF" : "inherit"
        }}>
          {this.getDefaultDisplayValue(item)}
        </p>
      </div>
    );
  }
  
  render() {
    const { 
      showSuggestions, selectedIndex, scanMode, isScanning, 
      inputValue, dropdownDirection, showInfoText 
    } = this.state;
    
    const {
      label,
      placeholder,
      Addbuttonclick,
      Addbutntext,
      showsearch,
      searchbtnclick,
      errorMessage,
      renderSuggestion,
      sideButton,
      sideButtonClick,
      disabled,
      showSideLoader,
      isMandatory,
      infoText,
      tooltipPosition = "bottom",
      tooltipOffset = "0",
      tooltipWidth = null,
      onScan,
    } = this.props;
    
    const filteredData = this.getFilteredData();
    
    return (
      <div
        style={{ position: "relative" }}
        ref={this.wrapperRef}
      >
        {/* Label */}
        <div 
        // style={{ marginBottom: "5px" }}
        >
          {label && (
            <label
              style={{ 
                marginBottom: "",
                color: errorMessage ? "#B91C1C" : "#000000"
              }}
            >
              {label} {isMandatory && <span style={{ color: "#B91C1C" }}>*</span>}
              {infoText && (
                <div style={{ position: "relative", display: "inline-flex" }}>
                  <span 
                    onClick={() => { this.setState({ showInfoText: !showInfoText }) }} 
                    onMouseEnter={() => { this.setState({ showInfoText: true }) }} 
                    onMouseLeave={() => { this.setState({ showInfoText: false }) }} 
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: "4px",
                      border: "1px solid rgb(108,113,138)",
                      color: "rgb(108,113,138)",
                      borderRadius: "9999px",
                      width: "16px",
                      height: "16px",
                      textAlign: "center",
                      lineHeight: "16px",
                      fontSize: "10px",
                      cursor: "pointer"
                    }}
                  >
                    i
                  </span>
                  {showInfoText && (
                    <div
                      style={{
                        zIndex: 50,
                        padding: "8px 12px",
                        borderRadius: "8px",
                        whiteSpace: "normal",
                        position: isMobileApp() ? "fixed" : "absolute",
                        left: isMobileApp() ? "0" : "50%",
                        right: isMobileApp() ? "0" : "auto",
                        justifyContent: isMobileApp() ? "center" : "flex-start",
                        width: isMobileApp() ? "100%" : (tooltipWidth || "auto"),
                        background: "#4A1E73",
                        color: "#FFFFFF",
                        transform: isMobileApp() ? "none" : "translateX(-50%)",
                        top: isMobileApp() ? "0" : "auto",
                        marginTop: !isMobileApp() && tooltipPosition === "bottom" ? "8px" : "0",
                        marginBottom: !isMobileApp() && tooltipPosition === "top" ? "8px" : "0"
                      }}
                    >
                      {isMobileApp() && (
                        <span
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            width: "24px",
                            height: "24px",
                            background: "#EF4444",
                            borderRadius: "9999px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer"
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({ showInfoText: false });
                          }}
                          aria-label="Close tooltip"
                        >
                          <span style={{ width: "16px" }}>
                            <Icon type="remove" />
                          </span>
                        </span>
                      )}
                      {infoText}
                    </div>
                  )}
                </div>
              )}
            </label>
          )}
        </div>
        
        {/* Input Container */}
        <div
          style={{
            height: "34px",
            backgroundColor: disabled ? "#EEEEEE" : "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "8px",
            border: `1px solid ${errorMessage ? "#B91C1C" : (scanMode ? "#408dfb" : "#d7d5e2")}`,
            boxShadow: scanMode ? "0 0 0 3px rgba(64, 141, 251, 0.16)" : "none"
          }}
        >
          {/* Search Icon */}
          {showsearch && (
            <span
              style={{
                width: "40px",
                padding: "0 8px",
                color: "#9CA3AF",
                cursor: "pointer"
              }}
              onClick={searchbtnclick}
            >
              <Icon type="search" />
            </span>
          )}
          
          {/* Scan Button */}
          {onScan && (
            <span
              style={{
                width: "40px",
                padding: "0 8px",
                color: scanMode ? "#2563EB" : "#9CA3AF",
                cursor: "pointer"
              }}
              onClick={this.toggleScanMode}
              title={scanMode ? "Exit scan mode" : "Enter scan mode"}
            >
              <Icon type={scanMode ? "barcode-active" : "barcode"} />
            </span>
          )}
          
          <input
            ref={this.inputRef}
            type="text"
            value={inputValue}
            onChange={this.handleInputChange}
            onFocus={this.handleFocus}
            placeholder={scanMode ? "Start scanning to search products" : placeholder}
            style={{
              width: "100%",
              padding: "0 8px",
              color: "#374151",
              border: "none",
              borderRadius: "8px",
              outline: "none",
              background: "none"
            }}
            onKeyDown={this.handleKeyDown}
            disabled={disabled}
          />
          
          {/* Clear Button */}
          {(inputValue && !disabled) && (
            <span
              style={{
                display: "inline-block",
                width: "32px",
                color: "#9CA3AF",
                paddingRight: "8px",
                cursor: "pointer",
                background: "none"
              }}
              onClick={() => {
                this.props.onChange("");
                this.setState({ 
                  inputValue: "",
                  forceShowAll: true,
                  isTyping: false,
                  isScanning: false
                });
              }}
            >
              <Icon type="remove" />
            </span>
          )}
          
          {/* Dropdown Toggle */}
          {!disabled && !scanMode && (
            <span
              style={{
                display: "inline-block",
                width: "32px",
                color: "#9CA3AF",
                paddingRight: "8px",
                cursor: "pointer",
                background: "none"
              }}
              onClick={this.handleToggleSuggestions}
            >
              {showSuggestions && <Icon type="uparrow" />}
              {!showSuggestions && <Icon type="downarrow" />}
            </span>
          )}
          
          {/* Side Loader */}
          {showSideLoader && (
            <div style={{ paddingRight: "8px" }}>
              <span style={{
                width: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <div style={{
                  width: "20px",
                  height: "20px",
                  border: "2px solid #BE007B",
                  borderTopColor: "transparent",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite"
                }}></div>
              </span>
            </div>
          )}
          
          {/* Side Button */}
          {sideButton && (
            <span
              style={{
                padding: "0 8px",
                borderLeft: "1px solid #d7d5e2",
                height: "34px",
                paddingTop: "6px",
                color: "#6B7280",
                cursor: "pointer",
                whiteSpace: "nowrap"
              }}
              onClick={sideButtonClick}
            >
              {sideButton}
            </span>
          )}
        </div>
        
        {/* Error Message */}
        {errorMessage && <p style={{ marginTop: "4px", color: "#B91C1C" }}>{errorMessage}</p>}
        
        {/* Scan Mode Indicator */}
        {scanMode && (
          <div style={{
            position: "absolute",
            marginTop: "4px",
            left: "0",
            right: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <div style={{
              backgroundColor: "#DBEAFE",
              border: "1px solid #93C5FD",
              color: "#1D4ED8",
              padding: "4px 12px",
              borderRadius: "8px",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
            }}>
              <span style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#3B82F6",
                borderRadius: "50%",
                animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
              }}></span>
              <span style={{ fontWeight: "500" }}>Scan Mode Active</span>
              <span style={{ fontSize: "12px" }}>(Press Enter to scan, Esc to exit)</span>
            </div>
          </div>
        )}
        
        {/* Scanning Loader */}
        {isScanning && (
          <div style={{
            position: "absolute",
            marginTop: "4px",
            left: "0",
            right: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 20
          }}>
            <div style={{
              backgroundColor: "white",
              border: "1px solid #93C5FD",
              color: "#1D4ED8",
              padding: "4px 12px",
              borderRadius: "8px",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)"
            }}>
              <div style={{
                width: "20px",
                height: "20px",
                border: "2px solid #3B82F6",
                borderTopColor: "transparent",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }}></div>
              <span style={{ fontWeight: "500" }}>Scanning...</span>
              <span style={{ fontSize: "12px" }}>Please wait</span>
            </div>
          </div>
        )}
        
        {/* Suggestions Dropdown */}
        {showSuggestions && !scanMode && (
          <div 
            style={{
              position: "absolute",
              width: "100%",
              zIndex: 10,
              borderRadius: "8px",
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
              backgroundColor: "white",
              maxHeight: "240px",
              marginTop: dropdownDirection === 'down' ? "6px" : "0",
              marginBottom: dropdownDirection === 'up' ? "6px" : "0",
              bottom: dropdownDirection === 'up' ? "100%" : "auto"
            }}
          >
            <div style={{
              position: "relative",
              zIndex: 10,
              marginTop: "6px",
              width: "100%",
              borderRadius: "8px",
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
              backgroundColor: "white",
              maxHeight: "240px",
              display: "flex",
              flexDirection: "column"
            }}>
              <div
                style={{
                  flex: 1,
                  overflowY: "auto"
                }}
                ref={this.suggestionsRef}
              >
                {filteredData.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "12px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "4px",
                      cursor: "pointer",
                      backgroundColor: selectedIndex === index ? "#6e2d90" : (this.isItemSelected(item) ? "#F5EBFB" : "transparent"),
                      color: selectedIndex === index ? "#FFFFFF" : "inherit"
                    }}
                    onClick={() => this.handleItemClick(item)}
                    onMouseEnter={() => this.setState({ selectedIndex: index })}
                    ref={(el) => (this.itemRefs[index] = el)}
                  >
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      {renderSuggestion
                        ? renderSuggestion(item, index)
                        : this.defaultRenderSuggestion(item, index)}
                    </div>
                    {this.isItemSelected(item) && (
                      <span style={{ width: "12px", color: "#6e2d90" }}>
                        <Icon type="check" />
                      </span>
                    )}
                  </div>
                ))}
                {filteredData.length === 0 && (
                  <div style={{ padding: "12px", color: "#6B7280" }}>
                    No results found
                  </div>
                )}
              </div>
              
              {Addbutntext && (
                <div style={{
                  borderTop: "1px solid #E5E7EB",
                  padding: "12px"
                }}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#6e2d90",
                      cursor: "pointer"
                    }}
                    onClick={Addbuttonclick}
                  >
                    <span style={{ width: "40px" }}>
                      <Icon type="add" />
                    </span>
                    <span style={{ marginLeft: "8px" }}>{Addbutntext}</span>
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
        
        {/* Add CSS animations */}
        <style>
          {`
            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
            
            @keyframes pulse {
              0%, 100% {
                opacity: 1;
              }
              50% {
                opacity: 0.5;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default Autocompletesearch;